import type { ButtonBaseProps } from '@mui/material/ButtonBase';

import { useParams } from 'react-router-dom';
import { useShallow } from 'zustand/react/shallow';
import { useState, useEffect, useCallback } from 'react';

import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
import MenuList from '@mui/material/MenuList';
import ButtonBase from '@mui/material/ButtonBase';
import MenuItem, { menuItemClasses } from '@mui/material/MenuItem';

import { useRouter } from 'src/routes/hooks';

import { AppsApi } from 'src/service/apps';
import { varAlpha } from 'src/theme/styles';
import { appsModel } from 'src/store/appsModel';

import { Label } from 'src/components/label';
import { Iconify } from 'src/components/iconify';

export type WorkspacesPopoverProps = ButtonBaseProps & {
  data?: {
    id: string;
    name: string;
    logo: string;
    plan: string;
  }[];
};

export function WorkspacesPopover({ data = [], sx, ...other }: WorkspacesPopoverProps) {
  const [openPopover, setOpenPopover] = useState<HTMLButtonElement | null>(null);

  const { apps } = appsModel(useShallow((state) => state));

  const [workspace, setWorkspace] = useState<number | null>(null);

  const iddd = useParams().id || '';

  const handleOpenPopover = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setOpenPopover(event.currentTarget);
  }, []);

  const handleClosePopover = useCallback(() => {
    setOpenPopover(null);
  }, []);

  const handleChangeWorkspace = useCallback(
    (appId: number) => {
      // setWorkspace(appId);
      handleClosePopover();
      AppsApi.getAppById(appId)
      window.location.href = `/dashboard/projects/${appId}/content`;
      // router.replace(`projects/${appId}/content`); // Navigate to the new workspace

    },
    [handleClosePopover]
  );

  const projectApps = apps?.data;
  const project = projectApps?.find((app) => app.app.id === workspace);

  useEffect(() => {
    if (iddd) {
      setWorkspace(+iddd)
    } else {
      setWorkspace(null)
    }
  }, [iddd]);

  const renderAvatar = (alt: string, src: string) => (
    <Box component="img" alt={alt} src={src} sx={{ width: 24, height: 24, borderRadius: '50%' }} />
  );

  const renderLabel = (plan: string) => (
    <Label color={plan === 'Free' ? 'default' : 'info'}>{plan}</Label>
  );

  return (
    <>
      <ButtonBase
        disableRipple
        onClick={handleOpenPopover}
        sx={{
          pl: 2,
          py: 3,
          gap: 1.5,
          pr: 1.5,
          width: 1,
          borderRadius: 1.5,
          textAlign: 'left',
          justifyContent: 'flex-start',
          bgcolor: (theme) => varAlpha(theme.vars.palette.grey['500Channel'], 0.08),
          ...sx,
        }}
        {...other}
      >
        {/* {renderAvatar('IA', '')} */}

        <Box
          gap={1}
          flexGrow={1}
          display="flex"
          alignItems="center"
          sx={{ typography: 'body2', fontWeight: 'fontWeightSemiBold' }}
        >
          {project?.app?.name ? 'Project' : 'No Project Selected'}
          {project?.app?.name && renderLabel(project?.app?.name)}
        </Box>

        <Iconify width={16} icon="carbon:chevron-sort" sx={{ color: 'text.disabled' }} />
      </ButtonBase>

      <Popover open={!!openPopover} anchorEl={openPopover} onClose={handleClosePopover}>
        <MenuList
          disablePadding
          sx={{
            p: 0.5,
            gap: 0.5,
            width: 260,
            display: 'flex',
            flexDirection: 'column',
            [`& .${menuItemClasses.root}`]: {
              p: 1.5,
              gap: 1.5,
              borderRadius: 0.75,
              [`&.${menuItemClasses.selected}`]: {
                bgcolor: 'action.selected',
                fontWeight: 'fontWeightSemiBold',
              },
            },
          }}
        >
          {projectApps?.map(({ app }) => (
            <MenuItem
              key={app.id}
              selected={app.id === workspace}
              onClick={() => handleChangeWorkspace(app.id)}
            >
              {/* {renderAvatar('IA', '')} */}

              <Box component="span" sx={{ flexGrow: 1 }}>
                Select  
              </Box>

              {renderLabel(app.name)}
            </MenuItem>
          ))}
        </MenuList>
      </Popover>
    </>
  );
}
